import React from "react";

export default function ExpertOptions({
  options,
  className,
  optionName,
  handleOptionChange,
}) {
  console.log("OPTIONS", options);
  return (
    <div className="row mb-xl-5 pb-xl-2 mb-4">
      {options.map((option) => {
        return (
          <div className={`form-group ${className}`}>
            <input
              type="checkbox"
              name={option.description}
              id={option.description}
              onChange={(e) => handleOptionChange(optionName, option.id)}
            />
            <label for={option.description}>{option.description}</label>
          </div>
        );
      })}
    </div>
  );
}
